import { spacing } from "../../layout";
import { SpacingProps, SpacingSizes } from "./types";

export const Spacing = ({ size = SpacingSizes.M }: SpacingProps) => {
  return <div style={{ height: spacing[size] }} />;
};
